module.exports = __webpack_public_path__ + "img/shebeiguanliW.eb4cc1c0.png";